<div class="page-title">Professional Account Sign Up</div>
<div class="page-sub-title-alt">
  Already registered with MindBerry?

  <div class="centered push-down-20">
    <a class="btn-main" routerLink="/login">Login</a>
  </div>
</div>

<!-- Signup Success -->
<div class="col-lg-6 col-md-8 col-sm-10 col-lg-offset-3 col-md-offset-2 col-sm-offset-1 push-up-50 push-down-50"
  *ngIf="signupStatus == true">
  <div class="panel-auth">
    <img class="title-img" src="/images/veri-a.jpg" />

    <div class="col-md-10 col-sm-12 col-md-offset-1 col-sm-offset-0">
      <h5 class="panel-title push-down-30">Please verify your email address</h5>

      <div class="col-sm-12">
        <div class="push-up-20">
          <div class="profile-sec-wrap">
            <div class="panel-sub-title">
              We have sent you a verification email. Please click the link within to complete your account verification
              and continue with the application process. You may need to check your junk folder.
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-8 col-sm-offset-2 push-down-10 push-up-30">
        <a class="btn-main-proceed-alt" (click)="resend()">Resend verification</a>
      </div>
    </div>
    <div class="clear"></div>
  </div>
  <div class="clear"></div>
</div>

<form [formGroup]="myForm" (ngSubmit)="onSubmit()">
  <div id="" *ngIf="signupStatus == null || signupStatus == false">
    <!-- Account/Login Details -->
    <div class="col-lg-8 col-md-10 col-sm-10 col-lg-offset-2 col-md-offset-1 col-sm-offset-1 nopadding-mobile">
      <div class="panel">
        <!--<div class="panel-title">Login Details</div>-->

        <h5 class="panel-title push-down-30">Account Title</h5>

        <p class="page-sub-title push-down-10">
          Please enter your email address and password. We recommend using an email address you have quick and regular
          access to, as this is where you will receive all notification emails regarding your account.
        </p>

        <div id="mbalertbox" class="mb-alert-box mb-alertbox-hide"></div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">Display Name</div>

            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['displayName']" [(ngModel)]="model.displayName"
                     placeholder="e.g. Dr Mind Berry" />
              <div class="mb-error-fail-wrap"
                   *ngIf="!myForm.controls['displayName'].valid && myForm.controls['displayName'].touched">
                <div class="mb-error-fail">Please enter a valid Display Name</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">Email Address</div>

            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['email']" [(ngModel)]="model.email" />
              <div class="mb-error-fail-wrap"
                   *ngIf="!myForm.controls['email'].valid && myForm.controls['email'].touched">
                <div class="mb-error-fail">Please enter a valid EMAIL ADDRESS</div>
              </div>
            </div>
          </div>
        </div>

        <div class="clear"></div>

        <div class="col-sm-12" *ngIf="!myForm.controls['password'].valid">
          <div class="profile-sec-wrap">
            <div class="panel-sub-title push-up-10">Your password must contain at least:</div>

            <div class="col-sm-6 nopadding">
              <ul class="auth-info-panel">
                <li>- Minimum 8 characters</li>
                <li>- Lowercase letters</li>
                <li>- Uppercase letters</li>
              </ul>
            </div>

            <div class="col-sm-6 nopadding">
              <ul class="auth-info-panel">
                <li>- Numbers</li>
                <li>- Special characters:</li>
                <li>&nbsp; !, @, #, $, %, ^, &</li>
              </ul>
            </div>

            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>

        <div class="col-md-6 col-sm-6">
          <div class="form-elem">
            <div class="form-elem-name">Password</div>

            <div class="form-elem-field">
              <input type="password" id="password" [formControl]="myForm.controls['password']"
                     [(ngModel)]="model.password" />
              <div class="mb-error-fail-wrap"
                   *ngIf="!myForm.controls['password'].valid && myForm.controls['password'].touched">
                <div class="mb-error-fail">Please enter a valid PASSWORD</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-6">
          <div class="form-elem">
            <div class="form-elem-name">Confirm Password</div>

            <div class="form-elem-field">
              <input type="password" id="confirmPassword" [formControl]="myForm.controls['confirmPassword']"
                     [(ngModel)]="model.confirmPassword" />
              <div class="mb-error-fail-wrap"
                   *ngIf="!myForm.controls['confirmPassword'].valid && myForm.controls['confirmPassword'].touched">
                <div class="mb-error-fail">Please enter a valid PASSWORD</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12" *ngIf="myForm.controls['password'].valid && myForm.controls['confirmPassword'].valid">
          <div class="pass-ok">
            <h4>Password Acceptable</h4>
          </div>
          <div class="clear"></div>
        </div>

        <div class="clear"></div>
      </div>
    </div>

    <!-- Personal Details -->
    <div class="col-lg-8 col-md-10 col-sm-10 col-lg-offset-2 col-md-offset-1 col-sm-offset-1 nopadding-mobile">
      <div class="panel">
        <div class="panel-title">Personal Details</div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">First Name</div>
            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['firstname']" [(ngModel)]="model.firstname" />
            </div>
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['firstname'].valid && myForm.controls['firstname'].touched">
              <div class="mb-error-fail">Please enter your FIRST NAME</div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">Last Name</div>
            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['lastname']" [(ngModel)]="model.lastname" />
            </div>
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['lastname'].valid && myForm.controls['lastname'].touched">
              <div class="mb-error-fail">Please enter your LAST NAME</div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-elem-inner">
            <div class="form-elem-name">Gender</div>
            <div class="form-elem-field">
              <select [formControl]="myForm.controls['gender']" [(ngModel)]="model.gender">
                <option></option>
                <option [ngValue]="0">Male</option>
                <option [ngValue]="1">Female</option>
                <option [ngValue]="2">Other</option>
              </select>
              <div class="clear"></div>
              <div class="mb-error-fail-wrap"
                   *ngIf="!myForm.controls['gender'].valid && myForm.controls['gender'].touched">
                <div class="mb-error-fail">Please select your GENDER</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-elem">
            <div class="">
              <div class="form-elem-name">Nationality</div>
              <div class="form-elem-field">
                <select [(ngModel)]="model.nationality" [formControl]="myForm.controls['nationality']">
                  <option [ngValue]="">Please Select</option>
                  <option *ngFor="let item of nationalityList" [ngValue]="item">{{item.name}}</option>
                </select>
              </div>
            </div>
            <div *ngIf="!myForm.controls['nationality'].valid && myForm.controls['nationality'].touched"
                 class="mb-error-fail-wrap">
              <div class="mb-error-fail">Please select your NATIONALITY</div>
            </div>
          </div>
        </div>

        <div class="clear"></div>

        <div class="col-sm-12">
          <div class="form-elem-inner">
            <div class="form-elem-name">Date of Birth</div>
            <div class="form-elem-field formsec-date">
              <date-input-control [minAge]="globalSettings.minAge" [dobForm]="myForm.controls['dob']"
                                  (OnDateSelected)="dateSelected($event)">
              </date-input-control>
            </div>
            <input type="text" [(ngModel)]="model.age" [formControl]="myForm.controls['age']" hidden="hidden" />
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Details -->
    <div class="col-lg-8 col-md-10 col-sm-10 col-lg-offset-2 col-md-offset-1 col-sm-offset-1 nopadding-mobile">
      <div class="panel">
        <div class="panel-title">Contact Details </div>

        <div class="col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">Address Line 1</div>
            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['addressLine1']" [(ngModel)]="model.addressLine1" />
            </div>
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['addressLine1'].valid && myForm.controls['addressLine1'].touched">
              <div class="mb-error-fail">Please enter your ADDRESS</div>
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">Address Line 2</div>
            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['addressLine2']" [(ngModel)]="model.addressLine2" />
            </div>
          </div>
        </div>

        <div class="clear"></div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">City</div>

            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['city']" [(ngModel)]="model.city" />
              <div class="mb-error-fail-wrap" *ngIf="!myForm.controls['city'].valid && myForm.controls['city'].touched">
                <div class="mb-error-fail">Please enter your CITY</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">Post/Zip Code</div>

            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['postcode']" [(ngModel)]="model.postcode" />
              <div class="mb-error-fail-wrap"
                   *ngIf="!myForm.controls['postcode'].valid && myForm.controls['postcode'].touched">
                <div class="mb-error-fail">Please enter your POST CODE</div>
              </div>
            </div>
          </div>
        </div>

        <div class="clear"></div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">Mobile</div>
            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['mobile']" [(ngModel)]="model.mobile" />
            </div>
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['mobile'].valid && myForm.controls['mobile'].touched">
              <div class="mb-error-fail">Please enter your MOBILE NUMBER</div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-elem">
            <div class="">
              <div class="form-elem-name">Country</div>
              <div class="form-elem-field">
                <select [(ngModel)]="model.country" [formControl]="myForm.controls['country']">
                  <option [ngValue]="">Please Select</option>
                  <option *ngFor="let item of countryList" [ngValue]="item">{{item.name}}</option>
                </select>
              </div>
            </div>
            <div *ngIf="!myForm.controls['country'].valid && myForm.controls['country'].touched"
                 class="mb-error-fail-wrap">
              <div class="mb-error-fail">Please enter your COUNTRY</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Professional Experience -->
    <div class="col-lg-8 col-md-10 col-sm-10 col-lg-offset-2 col-md-offset-1 col-sm-offset-1 nopadding-mobile">
      <div class="panel">
        <div class="panel-title">Professional Experience</div>

        <div class="col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">Highest Qualification</div>
            <div class="form-elem-field">
              <textarea [formControl]="myForm.controls['qualification']" [(ngModel)]="model.qualification"></textarea>
            </div>
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['qualification'].valid && myForm.controls['qualification'].touched">
              <div class="mb-error-fail">Please provide your HIGHEST QUALIFICATION</div>
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-elem">
            <div class="form-elem-name">Experience (Years)</div>
            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['experience']" [(ngModel)]="model.experience" />
            </div>
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['experience'].valid && myForm.controls['experience'].touched">
              <div class="mb-error-fail">Please Enter your EXPERIENCE in years</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="clear"></div>

    <div class="col-lg-4 col-md-6 col-sm-8 col-lg-offset-4 col-md-offset-3 col-sm-offset-2 push-down-20 push-up-50">
      <input class="btn-main-proceed-alt" type="submit" value="Next" name="" id="" />
    </div>

    <div class="clear"></div>
  </div>
</form>
